import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography } from "antd";
import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";

const { Title } = Typography;

const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const Dashboard_s = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const [dataBar1, _dataBar1] = useState();
  const [dataBar2, _dataBar2] = useState();
  const [dataBar3, _dataBar3] = useState();

  useEffect(() => {
    Find_barData("bar1");
    Find_barData("bar2");
    Find_barData("bar3");
  }, []);

  const Find_barData = order => {
    axios
      .post(xURL + "db_barchart_db3_S", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            if (order == "bar1") {
              Tb1.push({
                name: i.name,
                zcount: i.zcount
              });
            } else if (order == "bar2") {
              const adYear = parseInt(i.name, 10) - 543; // พศ → คศ

              if (adYear !== 2022) {
                Tb1.push({
                  name: adYear.toString(),
                  zcount: i.zcount
                });
              }
            } else if (order == "bar3") {
              Tb1.push({
                name: i.name,
                zcount: i.zcount
              });
            }
          });
        }

        if (order == "bar1") {
          _dataBar1(Tb1);
        } else if (order == "bar2") {
          _dataBar2(Tb1);
        } else if (order == "bar3") {
          _dataBar3(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          Sustainable growth
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #d6fdc4ff"
            }}
            title="[KR11] ทุนวิจัย (ล้านบาท/ปี)"
          >
            <Barchart dataBar={dataBar1} order={"S1"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลตามปีงบประมาณ
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #d6fdc4ff"
            }}
            title="[KR12] รายได้นอกเหนือจากทุนวิจัย (ล้านบาท/ปี)"
          >
            <Barchart dataBar={dataBar2} order={"S2"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลตามปีงบประมาณ
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #d6fdc4ff"
            }}
            title="ทุนวิจัยบริษัทยา (ล้านบาท/ปี)"
          >
            <Barchart dataBar={dataBar3} order={"S3"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลตามปีงบประมาณ
            </div>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard_s;
